import React, { Fragment, useEffect, useState } from "react";
import Radio from "@material-ui/core/Radio";    
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import clsx from "clsx";

import CheckCircleIcon from "../../assets/CheckCircleIcon";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import classnames from 'classnames'
import { useDispatch } from 'react-redux'

import Grid from '@material-ui/core/Grid'
import { getMemberships } from '../../store/actions/membershipActions'
import { CircularProgress } from "@material-ui/core";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MembershipBenefits from "./MembershipBenefits";

const useStyles = makeStyles(theme => ({
    root: {
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    icon: {
        borderRadius: "50%",
        width: 24,
        height: 24,
        border: '1px solid black'
    },
    checkedIcon: {
        color: "black",
        boxShadow: "none",
        border: 'none',
        width: 26,
        height: 26,
    },

}));

const styles = theme => ({
    loaderDiv: {
        padding: theme.spacing(3)
    },
    label: {
        fontWeight: 500,
        fontSize: theme.spacing(2.5)
    },
    marginTop3: {
        marginTop: theme.spacing(3)
    },
    subText: {
        color: theme.palette.text.primary
    },
    line: {
        borderTop: '1px solid #9193949e',

    },
    padding1half: {
        padding: theme.spacing(1.5)
    },
    blackBorderButton: {

        border: '1px solid black',
        color: 'black',
        '&:hover': {
            backgroundColor: 'transparent',
            border: '1px solid black '
        }
    },
    accordionDetails:{
        display: 'flex',
        flexDirection: 'column'
    }

})

function StyledRadio(props) {
    const classes = useStyles();

    return (
        <div>


            <Radio
                className={classes.root}
                disableRipple
                color="default"
                checked
                checkedIcon={
                    <CheckCircleIcon
                        className={clsx(classes.icon, classes.checkedIcon)}
                        fontSize="large"
                    />
                }
                icon={<span className={classes.icon} />}
                {...props}
            ></Radio>
        </div>
    );
}

const MembershipUpgrades = ({ classes, handleChange, upgradeOptions, defaultPricingSelected, benefitsList, expanded }) => {

    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    
    const [valueSelected, setValueSelected] = useState(defaultPricingSelected)

    useEffect(() => {
        setLoading(true)
        dispatch(getMemberships(() => {
            setLoading(false)
        }))
        
    }, [])

   

    const handleOnChange = (e) => {
        setValueSelected(e.target.value)
        handleChange(e.target.value)
    }

    return <Fragment>
        
        <FormControl component="fieldset" style={{ width: "100%" }}>
            <RadioGroup
                aria-label="membership_options"
                name="membership_options"
                value={valueSelected}
                onChange={handleOnChange}
            >

                {
                    loading && <Grid container item justifyContent="center" className={classes.loaderDiv}><CircularProgress></CircularProgress></Grid>
                }
                {
                    upgradeOptions.map(reg => {
                        return <Accordion defaultExpanded expanded={expanded}>
                                <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-label="Expand"
                                aria-controls="additional-actions1-content"
                                id="additional-actions1-header"
                                >
                                    <FormControlLabel
                                        style={{ justifyContent: "flex-start", marginRight: 0 }}
                                        labelPlacement="end"
                                        className={classnames(classes.label)}
                                        value={`${reg.priceId}`}
                                        classes={{ label: classes.label }}
                                        control={<StyledRadio disabled={reg.disabled} />}
                                        label={`${reg.displayName}`}
                                    />
                                    </AccordionSummary>
                                <AccordionDetails className={classes.accordionDetails}>
                                    <MembershipBenefits benefits={benefitsList} />
                                </AccordionDetails>
                            </Accordion>
                    })
                }

            </RadioGroup>
    </FormControl>
    </Fragment>

}

export default withStyles(styles)(MembershipUpgrades)